/*
 *
 * Login reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  UPDATE_USERNAME,
  UPDATE_PASSWORD,
  SUBMIT_USERNAME,
  SUBMIT_USERNAME_SUCCESS,
  SUBMIT_USERNAME_FAILURE,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  GO_TO_PAGE,
  RESET_STATE,
  BACK_TO_EMAIL,
  RESET_ERROR,
  SET_DOMAIN_AUTH_METHOD,
  REQUIRE_TWO_FA_CODE,
  UPDATE_TWO_FA_CODE,
  SUBMIT_TWO_FA_CODE,
  SUBMIT_TWO_FA_CODE_SUCCESS,
  SUBMIT_TWO_FA_CODE_FAILURE,
} from './constants';

// Describes pages/steps within Login paper
export const page = {
  username: 'username',
  password: 'password',
  twoFaCode: 'twoFaCode',
  forgotPassword: 'forgotPassword',
  message: 'message',
};

const initialState = fromJS({
  error: '',
  authMethod: null,
  domainAuthMethod: null,
  message: '',
  username: '',
  password: '',
  loading: false,
  resettingPassword: false,
  currentPage: page.username,
  twoFaCode: '',
  userId: 0,
});

function loginReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    case UPDATE_USERNAME:
      return state.set('username', action.username);
    case UPDATE_PASSWORD:
      return state.set('password', action.password);
    case SUBMIT_USERNAME:
      return state.set('loading', true).set('error', '');
    case SUBMIT_USERNAME_SUCCESS:
      return state
        .set('loading', false)
        .set('currentPage', page.password)
        .set('authMethod', action.authMethod);
    case SUBMIT_USERNAME_FAILURE:
      return state.set('loading', false).set('error', action.error);
    case LOGIN:
      return state.set('loading', true).set('error', '');
    case LOGIN_SUCCESS:
      return initialState;
    case LOGIN_FAILURE:
      return state
        .set('loading', false)
        .set('password', '')
        .set('error', action.error);
    case FORGOT_PASSWORD:
      return state.set('resettingPassword', true).set('message', '');
    case FORGOT_PASSWORD_SUCCESS:
      return state
        .set('resettingPassword', false)
        .set('currentPage', page.message)
        .set('message', action.message);
    case FORGOT_PASSWORD_FAILURE:
      return state.set('resettingPassword', false).set('error', action.error);
    case GO_TO_PAGE:
      return state.set('currentPage', action.pageName);
    case BACK_TO_EMAIL: {
      const username = state.get('username');

      return initialState.set('username', username);
    }
    case RESET_ERROR:
      return state.set('error', '');
    case RESET_STATE:
      return initialState;
    case SET_DOMAIN_AUTH_METHOD:
      return state.set('domainAuthMethod', {
        type: action.method,
        identityProviderId: action.identityProviderId,
      });
    case REQUIRE_TWO_FA_CODE:
      return state
        .set('currentPage', page.twoFaCode)
        .set('userId', action.userId)
        .set('loading', false)
        .set('error', '')
        .set('twoFaCode', '')
        .set('username', '')
        .set('password', '');
    case UPDATE_TWO_FA_CODE:
      return state.set('twoFaCode', action.code);
    case SUBMIT_TWO_FA_CODE:
      return state.set('loading', true).set('error', '');
    case SUBMIT_TWO_FA_CODE_SUCCESS:
      return initialState;
    case SUBMIT_TWO_FA_CODE_FAILURE:
      return state.set('loading', false).set('error', action.error);
    default:
      return state;
  }
}

export default loginReducer;
